export default __webpack_public_path__ + "static/media/5_Gewitter.c9e88647.png";